import config from "@/config/config";
import { RoomDTO } from "@/generated/openapi";
import { buildUrl } from "@/utils/navigationUtils";
import { sanitizeUrl } from "@braintree/sanitize-url"

class UrlService {

  public getImageUrl(room: RoomDTO): string|undefined {
    return room.imageUrl ? buildUrl(config.baseApiUrl, room.imageUrl) : undefined
  }

  public sanitizeThisUrl(url: string): string {
    return sanitizeUrl(url) ? sanitizeUrl(url) : ''
  }

}

const urlService = new UrlService();

export {
  urlService
};
